import { getSession } from "next-auth/react";

import NewsDetailAuthorAndDate from "../../components/elements/news/NewsDetailAuthorAndDate";
import NewsDetailHero from "../../components/elements/news/NewsDetailHero";
import { apiWrapper } from "../../utils/api/apiWrapper";
import SocialShareMarkdownRender from "../../components/common/SocialShareMarkdownRender";

import {
  kNewsDetailURL,
  kNewsTotalViewsUpdateURL,
} from "../../utils/constants/apiUrls";
import { customSeoConfig } from "../../utils/helpers/helpers";
import RecommendedNews from "../../components/elements/news/RecommendedNews";
import GrayHorizontalDivider from "../../components/common/GrayHorizontalDivider";

const NewsDetail = ({ userNewsViewed, articleData }) => {
  const userViewedNews = userNewsViewed?.viewed_news;
  const articleDetail = articleData?.article;

  const recommendedNewsList = articleData?.recommended_news;

  const {
    first_name: firstName,
    last_name: lastName,
    profile_picture: avatar,
  } = articleDetail.created_by;

  const authorName = `${firstName} ${lastName}`;

  return (
    <>
      {customSeoConfig(
        articleDetail.title,
        articleDetail.caption,
        articleDetail.thumbnail,
        articleDetail.public_url,
        "article"
      )}

      <NewsDetailHero
        thumbnail={articleDetail.thumbnail}
        title={articleDetail.title}
      />

      <NewsDetailAuthorAndDate
        authorAvatar={avatar}
        authorFullName={authorName}
        articleDateTime={articleDetail.published_on}
      />

      <GrayHorizontalDivider />

      <SocialShareMarkdownRender
        title={articleDetail.title}
        caption={articleDetail.caption}
        url={articleDetail.public_url}
        readTime={articleDetail.read_time}
        markdownData={articleDetail.content}
      />

      <GrayHorizontalDivider />

      {recommendedNewsList.length !== 0 && (
        <RecommendedNews recommendedNews={recommendedNewsList} />
      )}
    </>
  );
};

export default NewsDetail;

export const getServerSideProps = async (context) => {
  const guestUserToken = process.env.GUSET_USER_TOKEN
    ? process.env.GUSET_USER_TOKEN
    : GUEST_TOKEN;

  const data = await getSession(context);

  const userToken = data?.accessToken ? data.accessToken : guestUserToken;

  const articleSlug = context.query.slug;

  const { req, res } = context;

  // res.setHeader(
  //   "Cache-Control",
  //   "public, s-maxage=86400, stale-while-revalidate=60"
  // );

  const userNewsViewed = await apiWrapper.get(
    kNewsTotalViewsUpdateURL + `?slug=${articleSlug}`,
    userToken
  );

  const article = await apiWrapper.get(
    kNewsDetailURL + `?slug=${articleSlug}`,
    userToken
  );

  return {
    props: {
      userNewsViewed: userNewsViewed?.data,
      articleData: article?.data,
    },
  };
};
